import { CONTACT_TYPE } from '../../common/constants'
import { generateLocationData } from '../../utils/general'
import { SelectOption } from '../globalTypes'

interface ActivityContactSource {
    id: number
    contactType?: string
    contactPerson?: { firstName?: string; lastName?: string }
    contactCompany?: { name?: string } | null
}

interface ActivityContactCompanyItem {
    id: number
    contactCompany?: { name?: string } | null
}

interface ActivityLinkedItem {
    id?: number
    internalAppId?: number
    translations?: Record<string, { projectTitle?: string; propertyTitle?: string }> | null
    street?: string | null
    streetNumber?: string | null
    city: { name?: string }
    country: { name?: string }
}

export const formatActivityContactOption = (contact?: ActivityContactSource | null): SelectOption[] => {
    if (!contact?.id) return []

    if (contact.contactType === CONTACT_TYPE.PERSON) {
        return [
            {
                label: `${contact.contactPerson?.firstName ?? ''} ${contact.contactPerson?.lastName ?? ''}`.trim(),
                value: contact.id.toString(),
            },
        ]
    }

    return [
        {
            label: contact.contactCompany?.name ?? '',
            value: contact.id.toString(),
        },
    ]
}

export const formatActivityContactCompanyCollectionOptions = (contactCompany?: ActivityContactCompanyItem[] | null) => {
    if (!contactCompany?.length) return []

    return contactCompany
        .filter((item) => item.contactCompany) // Filter out items with null contactCompany
        .map((item) => ({
            value: item.id,
            label: item.contactCompany?.name,
        }))
}

// TODO: `project`/`property` nested under an Activity (from the /activity/contact endpoints) only ever
// includes id/internalAppId/street/streetNumber/agent - city, country, translations and propertyType/propertyService
// come back undefined, unlike the /activity endpoint which returns them fully. So the label below falls
// back to street/streetNumber when present and is otherwise blank. Check with backend to return this data. 
export const formatActivityProjectOptions = (project?: ActivityLinkedItem | ActivityLinkedItem[] | null) => {
    const currentLang = localStorage.getItem('i18nextLng')

    const createOption = (item: ActivityLinkedItem) => ({
        value: item?.id?.toString(),
        label: `ID: ${item.internalAppId || ''} - ${item?.translations?.[currentLang as string]?.projectTitle || ''}`,
        location: generateLocationData(item),
    })

    if (!project) return []

    return (Array.isArray(project) ? project : [project]).map(createOption)
}

export const formatActivityPropertyOptions = (property?: ActivityLinkedItem | ActivityLinkedItem[] | null) => {
    const currentLang = localStorage.getItem('i18nextLng')

    const createOption = (item: ActivityLinkedItem) => ({
        value: item?.id?.toString(),
        label: `ID: ${item.internalAppId || ''} - ${item.translations?.[currentLang as string]?.propertyTitle || generateLocationData(item)}`,
        location: generateLocationData(item),
    })

    if (!property) return []

    return (Array.isArray(property) ? property : [property]).map(createOption)
}

export const formatActivityReminderChannelOptions = (): SelectOption[] => {
    return [
        {
            label: 'Notifikacija',
            value: 'popup',
        },
    ]
}

export const formatActivityReminderMinutesOptions = (): SelectOption[] => {
    return [
        { label: '15 min', value: '15' },
        { label: '30 min', value: '30' },
        { label: '1 sat', value: '60' },
        { label: '2 sata', value: '120' },
        { label: '1 dan', value: '1440' },
        { label: '1 tjedan', value: '10080' },
    ]
}
